import styled from '@emotion/styled';
import { Box, Paper } from '@material-ui/core';
import { isInIFrame } from 'utils/services/kenticoSdk.service';

export const NameCell = styled.div`
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  font-weight: bold;
  color: #333;
`;

export const ProgressBar = styled.div<{ isSuccess: boolean }>`
  display: flex;
  align-items: center;
  width: 100%;
  flex-direction: ${isInIFrame ? 'column' : 'row'};

  progress[value] {
    -webkit-appearance: none;
    appearance: none;
    height: 5px;
    width: 100%;
    margin-right: 4px;
  }

  progress[value]::-webkit-progress-bar {
    background: #f1f1f1;
    border-radius: 2px;
    box-shadow: 0 2px 5px rgba(0, 0, 0, 0.25) inset;
  }
  progress::-webkit-progress-value {
    background: ${(props: { isSuccess: boolean }) => (props.isSuccess ? `#38AF49` : `#00A4E4`)};
    border-radius: 2px;
  }
`;

export const StatusCell = styled.div<{ textColor: string }>`
  color: ${({ textColor }) => textColor};
  font-weight: bold;
`;

export const IFrameStatusContainer = styled(Box)`
  display: flex;
  width: 100%;
  justify-content: space-between;
`;

export const ExpandButton = styled(Paper)<{ nest?: number }>`
  position: absolute;
  z-index: 1;
  border-radius: 50% !important;
  left: 50%;
  transform: translateX(-50%);
  transform: ${({ nest }) => `translateX(calc(-50% - ${nest ? (nest * (isInIFrame ? 24 : 48)) / 2 : 0}px))`};
  bottom: -17px;
`;
